export default "__VITE_ASSET__07593f4d__"